/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { any } from 'prop-types';
import { useSelector } from 'react-redux';
import { getFeatureFlag } from '../../../../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';
import KlarnaPaymentScript from '../KlarnaPaymentScript/KlarnaPaymentScript';
import { KlarnaProvider } from './KlarnaContext';

const KlarnaPaymentWrapper = ({ children }) => {
    const ffKlarnaPaymentEnabled = useSelector((state) => getFeatureFlag('is-klarna-payment-enabled')(state));

    if (ffKlarnaPaymentEnabled) {
        return (
            <KlarnaProvider>
                <KlarnaPaymentScript />
                { children }
            </KlarnaProvider>
        );
    }

    return children;
};

KlarnaPaymentWrapper.propTypes = {
    children: any.isRequired,
};

export default KlarnaPaymentWrapper;
